import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { toast } from "sonner";
import { api, eur, errMsg } from "@/lib/api";

const Stat = ({ label, value, accent, id }) => (
  <div className="border border-[#0F0F0F] bg-white p-5" data-testid={`stat-${id}`}>
    <span className="tag text-[#555]">{label}</span>
    <p className={`font-display font-black text-3xl tracking-tight mt-2 ${accent || ""}`}>{value}</p>
  </div>
);

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  const sendReport = async () => {
    try {
      const { data } = await api.post("/admin/weekly-report");
      toast.success(`Riepilogo inviato: ${data.orders} ordini, margine ${eur(data.margin)}`);
    } catch (er) { toast.error(errMsg(er)); }
  };
  if (!s) return <p className="tag">Caricamento...</p>;

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div className="flex items-end justify-between gap-4">
        <div>
          <span className="tag text-[#0033FF]">Panoramica</span>
          <h1 className="font-display font-black text-4xl tracking-tight">Dashboard</h1>
        </div>
        <div className="text-right">
          <button data-testid="send-weekly-report-button" onClick={sendReport} className="btn-ghost h-10 px-4 text-sm">Invia riepilogo ora</button>
          <p className="text-xs text-[#555] mt-1">Automatico ogni lunedì alle 8:00</p>
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        <Stat id="orders" label="Ordini" value={s.orders} />
        <Stat id="revenue" label="Ricavi clienti" value={eur(s.revenue)} />
        <Stat id="amazon-cost" label="Costo Amazon" value={eur(s.amazon_cost)} />
        <Stat id="margin" label="Margine netto" value={eur(s.margin)} accent="text-[#0033FF]" />
        <Stat id="products" label="Prodotti attivi" value={s.products} />
      </div>
      <div className="border border-[#0F0F0F] bg-white p-5 font-mono text-sm" data-testid="markup-formula">
        <span className="tag text-[#555] block mb-2">Regola di prezzo (nascosta al cliente)</span>
        Prezzo Amazon × {(1 + s.markup_pct / 100).toFixed(2)} = Prezzo negozio &nbsp;
        <span className="text-[#0033FF]">(+{s.markup_pct}% ricarico)</span>
      </div>
      <div className="border border-[#0F0F0F] bg-white p-5">
        <span className="tag text-[#555]">Ricavi e margine · ultimi 14 giorni</span>
        <div className="h-72 mt-4">
          {s.series.length === 0 ? (
            <p className="text-sm text-[#555]">Nessun ordine ancora.</p>
          ) : (
            <ResponsiveContainer width="100%" height={288}>
              <BarChart data={s.series}>
                <CartesianGrid stroke="#eee" vertical={false} />
                <XAxis dataKey="day" tick={{ fontSize: 11, fontFamily: "IBM Plex Mono" }} />
                <YAxis tick={{ fontSize: 11, fontFamily: "IBM Plex Mono" }} />
                <Tooltip formatter={(v) => eur(v)} />
                <Legend />
                <Bar dataKey="ricavi" fill="#0F0F0F" />
                <Bar dataKey="margine" fill="#0033FF" />
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </div>
  );
}
